import { Button } from '@cleartax/wg-library-button';
import { TCategories } from './index';

interface ICategoryNavbarButton {
  selectedCategory: string;
  toggleSidebar: (category: TCategories) => void;
  category: TCategories;
}
export const CategoryNavbarButton: React.FC<ICategoryNavbarButton> = ({
  selectedCategory,
  toggleSidebar,
  category,
}) => {
  return (
    <Button
      mergeClasses="override"
      onClick={() => toggleSidebar(category)}
      className="text-s-14 text-brand-1000 font-medium  cursor-pointer"
    >
      {category === 'individual' ? 'Individuals' : 'Businesses'}
      <span
        className={`${
          selectedCategory === category ? '' : 'rotate-180'
        } icon-up-arrow1 px-2 text-base inline-block pb-0.5`}
      ></span>
    </Button>
  );
};
